import React from "react";
import "./SkillCard.scss";
import { CircularProgressbar } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const SkillCard = ({ skill }) => {
  const { skillName, value } = skill;
  return (
    <div className='skill-card-wrap'>
      <div className='img-section'>
        <CircularProgressbar
          value={value}
          text={`${value}%`}
          counterClockwise={true}
          // background
          className="circle-bar"
          strokeWidth="11"
        />
        <h3>{skillName}</h3>
      </div>
    </div>
  );
};

export default SkillCard;
